import { Inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_PLATFORM_URL } from './config.service';
import { ApiServiceBase} from '../index';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class IcaService extends ApiServiceBase {

  constructor(
    injector: Injector,
    private readonly http: HttpClient,
    @Inject(API_BASE_PLATFORM_URL) private readonly platformApiUrl: string,
  ) {
    super('IcaService', injector);
  }

  getIcaEnabledTenants(feature: string): Observable<string[]>{
    return this.http.get<string[]>(`${this.platformApiUrl}/FeatureToggle/GetFeatureEnabledTenants/${feature}`);
  }

}
